/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `index` for the Caintra Connect frontend.
 * @module components/AppointmentRequestActions/index
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import React from "react";
import styles from "./AppointmentRequestActions.module.css";
import { useTranslation } from "react-i18next";
import { ReactComponent as LikeIcon } from "../../assets/icons/AppointmentRequestActions/LikeIcon.svg";

const AppointmentRequestActions = ({
  onReject,
  onApprove,
  onLike,
  loading,
  estado,
  isLiked,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.actionsSectionContainer}>
      <div className={styles.actionsSectionContent}>
        <div className={styles.buttonsContainer}>
          <button
            className={styles.rejectButton}
            onClick={onReject}
            disabled={loading}
          >
            <div className={styles.buttonContent}>
              {t("components.appointmentRequestActions.rejectRequest")}
            </div>
          </button>
          <button
            className={styles.approveButton}
            onClick={onApprove}
            disabled={loading}
          >
            <div className={styles.buttonContent}>
              {t("components.appointmentRequestActions.approveRequest")}
            </div>
          </button>
          <button
            className={`${styles.likeButton} ${
              isLiked ? styles.likeButtonPressed : ""
            }`}
            onClick={onLike}
            disabled={loading}
          >
            <LikeIcon className={styles.likeIcon} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppointmentRequestActions;
